import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import { useInstallationGuide } from '../../../hooks/useInstallationGuide';
import { WizardNavigation } from '../WizardNavigation';

/** Path to the Core splash image */
const CORE_SPLASH_PATH = '/assets/images/installation-guide/core-splash.png';

/**
 * WelcomeStep - Slide 1.2: Entry Point/Welcome screen
 * 
 * Welcome screen introducing the installation guide.
 * Sets mainStepId and advances to confirm-model when user clicks "Get Started".
 */
export const WelcomeStep: React.FC = () => {
  const { goToStep, setMainStepId } = useInstallationGuide();

  // Set tracking step ID
  useEffect(() => {
    setMainStepId('step_1_preInstall');
  }, [setMainStepId]);

  const handleGetStarted = () => {
    goToStep('confirm-model');
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Heading */}
      <Typography
        variant="h3"
        component="h1"
        sx={{
          mb: 1,
          textAlign: 'center',
        }}
      >
        {__('Welcome to the Fusus Core installation guide.')}
      </Typography>

      {/* Subheading */}
      <Typography
        variant="h6"
        sx={{
          mb: 3,
          textAlign: 'center',
          color: 'text.secondary',
        }}
      >
        {__("Let's get your Core connected.")}
      </Typography>

      {/* Core device image */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          my: 2,
        }}
      >
        <Box
          component="img"
          src={CORE_SPLASH_PATH}
          alt={__('Fusus Core device')}
          sx={{
            maxWidth: '80%',
            maxHeight: 250,
            objectFit: 'contain',
          }}
        />
      </Box>

      {/* Navigation */}
      <WizardNavigation
        primaryLabel={__('Get Started')}
        onPrimary={handleGetStarted}
      />
    </Box>
  );
};
